import { Checkbox, FormControl, InputLabel, ListItemText, MenuItem, Select } from "@mui/material"
import { useCallback } from "react"
import { IStatusProps, StatusPedido, TipoRelatorioVenda } from "../vendas.model"
import { useSnackbarCustom } from "hooks/useSnackCustom"
import { theme } from "theme";


const Status = (props: IStatusProps) => {
    const { addError } = useSnackbarCustom();

    const isTipoRelatorioVendas = useCallback((target: TipoRelatorioVenda | Array<StatusPedido> | StatusPedido) => {
        return target === TipoRelatorioVenda.PEDIDO || target === TipoRelatorioVenda.NOTA
    }, [])

    const handleChange = useCallback((e: any) => {
        const target = e.target.value as TipoRelatorioVenda | Array<StatusPedido>
        if (!target.length) {
            return addError({ message: "O campo status deve ter pelo menos 1 valor selecionado", closeable: true })
        }
        if (isTipoRelatorioVendas(target)) {
            props.onChange(target)
        }
        props.onChange(target)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <FormControl variant="outlined"
            disabled={props.disabled}
            sx={{
                width: props.width ?? '30%', height: '55px'
            }}>
            <InputLabel variant="standard" id="labelTipo">{props.title}</InputLabel>
            <Select id="selectStatusVendas"
                multiple={props.multiple ?? true}
                sx={{
                    width: '100%',
                    height: '100%'
                }}
                variant="standard"
                label="Tipo"
                value={props.values}
                renderValue={(selected) => {
                    if (Array.isArray(selected)) {
                        return selected.join(', ')
                    }
                    return selected
                }}
                onChange={handleChange}
            >
                {props.options.map((e, i) => {
                    return (
                        <MenuItem
                            key={i}
                            value={e}
                            id={`menu_item_status_vendas_${e}`}
                        >
                            <ListItemText primary={e} />
                            <Checkbox
                                sx={{ color: theme.palette.primary.main }}
                                checked={!isTipoRelatorioVendas(e) ? props.values.indexOf(e) > -1 : props.values === e}

                                color='primary'
                            />
                        </MenuItem>
                    );
                })}
            </Select>
        </FormControl>
    )
}
export default Status
